import { RewardForTournamentPosition } from './RewardForTournamentPosition';

export class RankingItem{
    private playerId:string;
    private playerName:string;
    public playerImg:string;
    private wins:number;
    private online:boolean;
    private free:boolean;
    private position:number;
    private positionInViewport:number;
    private me:boolean;
    private backgroundImg:string;
    private empty:boolean = false;
 
    public getCoins():number{
        if( this.wins > 0 ){
            return RewardForTournamentPosition.getReward( this.position )
        }
        return 0;
    }
    public getPositionInViewport():number{
        return this.positionInViewport;
    }

    public setBackgroundImg(backgroundImg:string):void{
        this.backgroundImg = this.backgroundImg;
    }
    setEmpty(empty:boolean):void{
        this.empty = empty;
    }
    s
    constructor(playerId:string, playerName:string, 
        playerImg:string, wins:number, online:boolean, 
        free:boolean, position:number, positionInViewport:number = -1 ) 
    {
        this.free = free;
        this.positionInViewport = positionInViewport;
        this.playerId = playerId;
        this.playerName = playerName;
        if( playerImg == "noName"){
            this.playerImg = "/assets/images/rankings/lists/ranking-list/EmptySlotPlayer.jpg";
        }else{
            this.playerImg = playerImg;
        }
        
        //playerImg;
        this.wins = wins;
        this.online = online;
        this.position = position;
    }

    getImg():string{
        return this.playerImg;
    }
    setMe(me:boolean) : void {
        this.me = me;
    }
    public isMe():boolean{
        return this.me;
    }
    public getPosition():number{
        return this.position;
    }
    public getPlayerName():string{
        return this.playerName;
    }
    public getWins():number{
        return this.wins;
    }

    public isEmpty():boolean{
        return this.empty;
    }
}